import gql from 'graphql-tag';

import STATUS_DOCKETS_FRAGMENT from './STATUS_DOCKETS_FRAGMENT';

const STATUS_FRAGMENT = gql`
	fragment serviceRunStatus on ServiceRun {
		id
		created
		planned
		cashReconciliationStatus
		coinsCollected
		notesCollected
		collectedVariance
		isOneCashBag
		cashBag
		restockType
		route {
			id
			name
		}

		driver {
			id
			username
			firstname
			lastname
			destroyed
			userSitePermissions {
				id
				expiresAt
				sitePermission {
					id
					policy
				}
			}
		}

		startLocation {
			id
			name
			coordinates
			destroyed
		}
		machineOrder
		routeOrderCalculationStatus
		routeOrderCalculationError

		vehicle {
			id
			name
			lastCoordinates
		}

		endLocation {
			id
			name
			coordinates
			destroyed
		}
		warehouse {
			id
			name
		}
		returnWarehouse {
			id
			name
		}
		
		serviceDockets {
			...statusDockets
		}
		pickLists {
			id
			isAnyItemPicked
		}

		brief
	}
	${STATUS_DOCKETS_FRAGMENT}
`;

export default STATUS_FRAGMENT;
